<template>
  <div>
    <!-- FORMULARIO DE CADASTRO PARA O VAREJO -->
    <div v-if="formatoTela == 'varejo'">
      <bar-manut single-entity="Cliente" :crud="this.localCrud" :disableSave="this.disableSave" :btn-delete="true"
        @closeform="handleCloseForm" @delete="apiDelete()" @save="handleSave()" @savenew="handleSave(true)">
      </bar-manut>
      <div class="row">
        <form-field ref="nome" v-model="part.nome" type="text" col="6" :metadata="metadata.part.nome" name="nome"
          :v-errors="errors" v-validate="metadata.part.nome.validator"></form-field>
      </div>
      <div class="row">
        <form-field ref="tppessoa" v-model="part.tppessoa" type="select" col="3" :metadata="metadata.part.tppessoa"
          name="tppessoa" :v-errors="errors" v-validate="metadata.part.tppessoa.validator"
          :disabled="part.part_com_movimento == 'S'"></form-field>
        <form-field v-if="part.tppessoa == 'J'" v-model="part.cnpjcpf" type="cnpj" col="3" label="Cnpj"
          :metadata="metadata.part.cnpjcpf" name="cnpjcpf" :v-errors="errors" v-validate="{
            cnpj: true,
            required: true,
            min: 14,
            max: 14
          }" :disabled="part.part_com_movimento == 'S'"></form-field>
        <form-field v-if="part.tppessoa == 'F'" v-model="part.cnpjcpf" type="number" col="3" label="Cpf"
          :metadata="metadata.part.cnpjcpf" name="cnpjcpf" :v-errors="errors" v-validate="{
            cpf: true,
            required: true,
            
            min: 11,
            max: 11
          }"></form-field>

        <form-field v-if="showPreencherCadastro" v-model="part.uf" type="text" col="1" :metadata="metadata.part.uf">
        </form-field>
        <v-button v-if="showPreencherCadastro" label="Preencher Cadastro" icon="" @click="handlePreencherCadastro()"
          title="Para uma pesquisa mais completa, informe o estado!"></v-button>
      </div>
      <div class="row">
        <form-field v-model="part.fone1" label="Telefone" type="fone" col="3" name="fone" :v-errors="errors"
          v-validate="{ required: true,  min: 10 }" mask=""></form-field>
        <form-field v-model="part.emaildanfe" type="text" col="8" :metadata="metadata.part.emaildanfe" case="lower"
          name="emaildanfe" :v-errors="errors" v-validate="metadata.part.emaildanfe.validator"></form-field>
        <form-field v-model="part.dtnasc" type="date" col="3" :metadata="metadata.part.dtnasc" name="dtnasc"
          :v-errors="errors" v-validate="metadata.part.dtnasc.validator"></form-field>
        <form-field v-model="part.sexo" type="select" col="3" :metadata="metadata.part.sexo" name="sexo"
          :v-errors="errors" v-validate="metadata.part.sexo.validator"></form-field>
      </div>
    </div>

    <!--
            FORMULARIO DE CADASTRO PARA O CONTROLE DE PEDIDOS
        -->
    <div id="controlepedidos" v-if="formatoTela == 'forcavendas'">
      <bar-manut single-entity="Cliente" :crud="this.localCrud" :disableSave="this.disableSave" :btn-delete="true"
        @closeform="handleCloseForm" @delete="apiDelete()" @save="handleSave(false)" @savenew="handleSave(true)">
      </bar-manut>
      <validation v-if="nfeValidations" class="mt-3" title="Erros de Validação" :showcontinueanyway="true"
        :messages="nfeValidations" @continueanyway="nfeValidateContinueAnyway"></validation>
      <div class="row">
        <form-field ref="tppessoa" v-model="part.tppessoa" type="select" col="4" :metadata="metadata.part.tppessoa"
          name="tppessoa" :v-errors="errors" v-validate="metadata.part.tppessoa.validator"
          :disabled="part.part_com_movimento == 'S'"></form-field>
        <form-field v-if="part.tppessoa == 'J'" v-model="part.cnpjcpf" type="cnpj" col="4" label="Cnpj"
          :metadata="metadata.part.cnpjcpf" name="cnpjcpf" id="cnpjcpf" :v-errors="errors"
          v-validate="{ cnpj: true, required: false, min: 14, max: 14 }"
          :disabled="part.part_com_movimento == 'S'"></form-field>
        <form-field v-if="part.tppessoa == 'F'" v-model="part.cnpjcpf" type="number" col="4" label="Cpf"
          :metadata="metadata.part.cnpjcpf" name="cnpjcpf" id="cnpjcpf" :v-errors="errors"
          v-validate="{ cpf: true, required: false,  min: 11, max: 11 }"></form-field>
        <form-field v-if="showPreencherCadastro" v-model="part.uf" type="text" col="1" :metadata="metadata.part.uf">
        </form-field>
        <v-button v-if="showPreencherCadastro" label="Preencher Cadastro" icon="" @click="handlePreencherCadastro()"
          title="Para uma pesquisa mais completa, informe o estado!"></v-button>
      </div>
      <div class="row">
        <form-field ref="nome" v-model="part.nome" type="text" col="12" :metadata="metadata.part.nome" name="nome"
          id="nome" :v-errors="errors" v-validate="metadata.part.nome.validator"></form-field>
        <form-field v-model="part.fantasia" type="text" col="12" :metadata="metadata.part.fantasia" name="fantasia"
          id="fantasia" :v-errors="errors" v-validate="metadata.part.fantasia.validator"></form-field>
      </div>
      <div v-if="part.tppessoa == 'J'" class="row">
        <form-field v-model="part.contricms" type="select" col="4" :metadata="metadata.part.contricms" name="contricms"
          id="contricms" :v-errors="errors" v-validate="metadata.part.contricms.validator"></form-field>
        <form-field v-if="part.contricms == 'S'" v-model="part.iest" type="text" col="4" :metadata="metadata.part.iest"
          name="iest" :v-errors="errors" v-validate="metadata.part.iest.validator"></form-field>
        <div class="w-100"></div>
        <form-field v-model="part.optsimples" type="select" col="4" :metadata="metadata.part.optsimples"
          name="optsimples" :v-errors="errors" v-validate="metadata.part.optsimples.validator"></form-field>
        <form-field v-model="part.tpcliente" type="select" col="4" :metadata="metadata.part.tpcliente" name="tpcliente"
          :v-errors="errors" v-validate="metadata.part.tpcliente.validator"></form-field>
        <form-field v-model="part.zfranca" type="select" col="4" :metadata="metadata.part.zfranca" name="zfranca"
          :v-errors="errors" v-validate="metadata.part.zfranca.validator"></form-field>
        <form-field v-if="part.zfranca == 'S'" v-model="part.inscsuframa" type="text" col="4"
          :metadata="metadata.part.inscsuframa" name="inscsuframa" :v-errors="errors"
          v-validate="metadata.part.inscsuframa.validator"></form-field>
        <form-field v-model="part.limcred" type="value" col="4" :metadata="metadata.part.limcred" name="limcred"
          :v-errors="errors" v-validate="metadata.part.limcred.validator"></form-field>
        <form-field v-model="part.tpentegov" type="select" col="4" :metadata="metadata.part.tpentegov" name="tpentegov"
          :v-errors="errors" v-validate="metadata.part.tpentegov.validator"></form-field>
      </div>
      <div class="row">
        <form-field v-model="part.codgrucli" type="select2" col="6" :metadata="metadata.part.codgrucli" name="codgrucli"
          :v-errors="errors" v-validate="metadata.part.codgrucli.validator" :add-button="true"
          @clickAdd="handleIncluir('grucli')"></form-field>
        <form-field v-model="part.codramo" type="select2" col="6" :metadata="metadata.part.codramo" name="codramo"
          :v-errors="errors" v-validate="metadata.part.codramo.validator" :add-button="true"
          @clickAdd="handleIncluir('ramoat')"></form-field>
        <form-field v-model="part.emaildanfe" type="text" col="6" :metadata="metadata.part.emaildanfe" case="lower"
          name="emaildanfe" :v-errors="errors" v-validate="metadata.part.emaildanfe.validator"></form-field>
      </div>
      <label-title v-if="loja_b2b" title="Vendas B2B" class="mt-2"></label-title>
      <div v-if="loja_b2b" class="row">
        <div class="col-12">
          <input-switch type="success" v-model="part.habilita_b2b" value-checked="S" value-unchecked="N"
            :metadata-field="metadata.part.habilita_b2b"></input-switch>
        </div>
      </div>
      <label-title title="Contatos" class="mt-2"></label-title>
      <div class="card ml-5 p-3 mb-2" v-for="(cont, index) in partcontato" :key="index">
        <div class="row">

          <form-field v-model="cont.nomecontato" type="text" col="12" :metadata="metadata.partcontato.nomecontato"
            name="nomecontato" :v-errors="errors" v-validate="metadata.partcontato.nomecontato.validator"
            :disabled="isView"></form-field>
          <form-field v-model="cont.email" type="email" col="3" :metadata="metadata.partcontato.email" name="email"
            id="email" :v-errors="errors" v-validate="metadata.partcontato.email.validator" :disabled="isView">
          </form-field>
          <form-field v-model="cont.fone1" type="fone" col="3" :metadata="metadata.partcontato.fone1" name="fone1"
            id="fone1" :v-errors="errors" v-validate="metadata.partcontato.fone1.validator" :disabled="isView">
          </form-field>
          <form-field v-model="cont.fone2" type="fone" col="3" :metadata="metadata.partcontato.fone2" name="fone2"
            :v-errors="errors" v-validate="metadata.partcontato.fone2.validator" :disabled="isView"></form-field>
          <form-field v-model="cont.fone3" type="fone" col="3" :metadata="metadata.partcontato.fone3" name="fone3"
            :v-errors="errors" v-validate="metadata.partcontato.fone3.validator" :disabled="isView"></form-field>
        </div>
        <div class="row">
          <div class="col">
            <v-button label="" title="Excluir Contato" icon="fa-trash" @click="handleDeleteContact(index)"></v-button>
            <v-button label="" :nb-btdef="index + 1 == part.partcontatoseq" title="Contato Preferencial" icon="fa-check"
              @click="handlePrefContact(index)"></v-button>
          </div>
        </div>
      </div>
      <div class="row pl-5 mb-3">
        <div class="col-md-12 col-12">
          <div class="btn-group">
            <a href="javascript:void(0);" class="btn btn-sm btn-outline-secondary" style="margin-right: 5px"
              @click="handleAddContact()">Adicionar Contato</a>
          </div>
        </div>
      </div>

      <label-title title="Endereço Principal" class="mb-2"></label-title>
      <div class="row pl-5 pb-3">
        <form-field v-model="part.cep" type="cep" col="3" :metadata="metadata.part.cep" name="cep" :v-errors="errors"
          v-validate="{ max: 8 }" @update="updateCep"></form-field>
        <div class="w-100"></div>
        <form-field v-model="part.ende" type="text" col="9" :metadata="metadata.part.ende" name="ende"
          :v-errors="errors" v-validate="{ max: 100 }"></form-field>
        <form-field v-model="part.endenr" type="text" col="3" :metadata="metadata.part.endenr" name="endenr"
          :v-errors="errors" v-validate="{ max: 40 }"></form-field>
        <form-field v-model="part.endecomp" type="text" col="6" :metadata="metadata.part.endecomp" name="endecomp"
          :v-errors="errors" v-validate="{ max: 100 }"></form-field>
        <form-field v-model="part.bairro" type="text" col="6" :metadata="metadata.part.bairro" name="bairro"
          :v-errors="errors" v-validate="{ max: 60 }"></form-field>
        <form-field v-model="part.uf" type="select2" col="6" :metadata="metadata.part.uf" name="uf" :v-errors="errors"
          v-validate="metadata.part.uf.validator"></form-field>
        <form-field v-model="part.codmun" type="select2" col="6" :metadata="metadata.part.codmun" name="codmun"
          :v-errors="errors" v-validate="" :select2="{ entity: 'mun/uf/' + part.uf, minlength: 2 }"></form-field>
        <form-field v-model="part.codpais" type="select2" col="6" :metadata="metadata.part.codpais" name="codpais"
          :v-errors="errors" v-validate="metadata.part.codpais.validator"></form-field>
      </div>
      <label-title title="Vendas" class="mb-2 mt-2"></label-title>
      <div class="row pl-5">
        <form-field v-model="part.codtabpre" type="select2" col="6" :metadata="metadata.part.codtabpre" name="codtabpre"
          :v-errors="errors" v-validate="metadata.part.codtabpre.validator"></form-field>
      </div>
      <div class="row pl-5">
        <form-field v-model="part.codcondicao" type="select2" col="6" :metadata="metadata.part.codcondicao"
          name="codcondicao" :v-errors="errors" v-validate="metadata.part.codcondicao.validator"></form-field>
      </div>
      <div class="row pl-5 pb-5">
        <form-field v-model="part.tpfrete" type="select" col="3" :metadata="metadata.part.tpfrete" :disabled="isView">
        </form-field>
        <form-field v-model="part.codparttr" type="select2" col="6" :metadata="metadata.part.codparttr" name="codparttr"
          :v-errors="errors" v-validate="metadata.part.codparttr.validator"></form-field>
      </div>

      <!-- <div v-if="administrador && metadata.part.codusuario.select2 && metadata.part.codusuario.select2.entity"> -->
      <div v-if="administrador">
        <div v-if="!showInfUsuario" class="mt-2 mb-2">
          <a href="javascript:void(0);" @click="showInfUsuario = true"><i class="fa fa-caret-down"
              aria-hidden="true"></i> Exibir
            informações de usuário</a>
        </div>
        <div v-if="showInfUsuario">
          <label-title title="Usuario vinculado ao cliente" class="mb-2 mt-2"></label-title><br />
          <div class="row">
            <form-field v-model="part.codusuario" type="select2" col="3" :metadata="metadata.part.codusuario"
              :disabled="isView" name="codusuario" :v-errors="errors" v-validate="metadata.part.codusuario.validator">
            </form-field>
          </div>
        </div>
      </div>
    </div>

    <!-- FORMULARIO DE CADASTRO DE TRANSPORTADORA (FORCA DE VENDAS OU QUANDO ACESSADO PELO PEDIDO) -->
    <div id="transportadora" v-if="transportadora">
      <bar-manut single-entity="Transportadora" :crud="this.localCrud" :disableSave="this.disableSave"
        :btn-delete="true" @closeform="handleCloseForm" @delete="apiDelete()" @save="handleSave(false)"
        @savenew="handleSave(true)">
      </bar-manut>
      <validation v-if="nfeValidations" class="mt-3" title="Erros de Validação" :showcontinueanyway="true"
        :messages="nfeValidations" @continueanyway="nfeValidateContinueAnyway"></validation>
      <div class="row">
        <form-field ref="nome" v-model="part.nome" type="text" col="12" :metadata="metadata.part.nome" name="nome"
          :v-errors="errors" v-validate="metadata.part.nome.validator"></form-field>
        <form-field v-model="part.fantasia" type="text" col="12" :metadata="metadata.part.fantasia" name="fantasia"
          :v-errors="errors" v-validate="metadata.part.fantasia.validator"></form-field>
      </div>
      <div class="row">
        <form-field ref="tppessoa" v-model="part.tppessoa" type="select" col="4" :metadata="metadata.part.tppessoa"
          name="tppessoa" :v-errors="errors" v-validate="metadata.part.tppessoa.validator"
          :disabled="part.part_com_movimento == 'S'"></form-field>
        <form-field v-if="part.tppessoa == 'J'" v-model="part.cnpjcpf" type="cnpj" col="4" label="Cnpj"
          :metadata="metadata.part.cnpjcpf" name="cnpjcpf" id="cnpjcpf" :v-errors="errors"
          v-validate="{ cnpj: true, required: false, min: 14, max: 14 }"
          :disabled="part.part_com_movimento == 'S'"></form-field>
        <form-field v-if="part.tppessoa == 'F'" v-model="part.cnpjcpf" type="number" col="4" label="Cpf"
          :metadata="metadata.part.cnpjcpf" name="cnpjcpf" id="cnpjcpf" :v-errors="errors"
          v-validate="{ cpf: true, required: false,  min: 11, max: 11 }"></form-field>
        <form-field v-if="showPreencherCadastro" v-model="part.uf" type="text" col="1" :metadata="metadata.part.uf">
        </form-field>
        <v-button v-if="showPreencherCadastro" label="Preencher Cadastro" icon="" @click="handlePreencherCadastro()"
          title="Para uma pesquisa mais completa, informe o estado!"></v-button>
      </div>
      <div class="row">
        <form-field ref="nome" v-model="part.nome" type="text" col="12" :metadata="metadata.part.nome" name="nome"
          :v-errors="errors" v-validate="metadata.part.nome.validator"></form-field>
        <form-field v-model="part.fantasia" type="text" col="12" :metadata="metadata.part.fantasia" name="fantasia"
          :v-errors="errors" v-validate="metadata.part.fantasia.validator"></form-field>
      </div>
      <label-title title="Contatos" class="mt-2"></label-title>
      <div class="card ml-5 p-3 mb-2" v-for="(cont, index) in partcontato" :key="index">
        <div class="row">
          <form-field v-model="cont.nomecontato" type="text" col="12" :metadata="metadata.partcontato.nomecontato"
            name="nomecontato" :v-errors="errors" v-validate="metadata.partcontato.nomecontato.validator"
            :disabled="isView"></form-field>
          <form-field v-model="cont.email" type="email" col="3" :metadata="metadata.partcontato.email" name="email"
            :v-errors="errors" v-validate="metadata.partcontato.email.validator" :disabled="isView"></form-field>
          <form-field v-model="cont.fone1" type="fone" col="3" :metadata="metadata.partcontato.fone1" name="fone1"
            :v-errors="errors" v-validate="metadata.partcontato.fone1.validator" :disabled="isView"></form-field>
          <form-field v-model="cont.fone2" type="fone" col="3" :metadata="metadata.partcontato.fone2" name="fone2"
            :v-errors="errors" v-validate="metadata.partcontato.fone2.validator" :disabled="isView"></form-field>
          <form-field v-model="cont.fone3" type="fone" col="3" :metadata="metadata.partcontato.fone3" name="fone3"
            :v-errors="errors" v-validate="metadata.partcontato.fone3.validator" :disabled="isView"></form-field>
        </div>
        <div class="row">
          <div class="col">
            <v-button label="" title="Excluir Contato" icon="fa-trash" @click="handleDeleteContact(index)"></v-button>
            <v-button label="" :nb-btdef="index + 1 == part.partcontatoseq" title="Contato Preferencial" icon="fa-check"
              @click="handlePrefContact(index)"></v-button>
          </div>
        </div>
      </div>
      <div class="row pl-5 mb-3">
        <div class="col-md-12 col-12">
          <div class="btn-group">
            <a href="javascript:void(0);" class="btn btn-sm btn-outline-secondary" style="margin-right: 5px"
              @click="handleAddContact()">Adicionar Contato</a>
          </div>
        </div>
      </div>

      <label-title title="Endereço" class="mb-2"></label-title>
      <div class="row pl-5 pb-3">
        <form-field v-model="part.cep" type="cep" col="3" :metadata="metadata.part.cep" name="cep" :v-errors="errors"
          v-validate="{ max: 8 }" @update="updateCep"></form-field>
        <div class="w-100"></div>
        <form-field v-model="part.ende" type="text" col="9" :metadata="metadata.part.ende" name="ende"
          :v-errors="errors" v-validate="{ max: 100 }"></form-field>
        <form-field v-model="part.endenr" type="text" col="3" :metadata="metadata.part.endenr" name="endenr"
          :v-errors="errors" v-validate="{ max: 40 }"></form-field>
        <form-field v-model="part.endecomp" type="text" col="6" :metadata="metadata.part.endecomp" name="endecomp"
          :v-errors="errors" v-validate="{ max: 100 }"></form-field>
        <form-field v-model="part.bairro" type="text" col="6" :metadata="metadata.part.bairro" name="bairro"
          :v-errors="errors" v-validate="{ max: 60 }"></form-field>
        <form-field v-model="part.uf" type="select2" col="6" :metadata="metadata.part.uf" name="uf" :v-errors="errors"
          v-validate="metadata.part.uf.validator"></form-field>
        <form-field v-model="part.codmun" type="select2" col="6" :metadata="metadata.part.codmun" name="codmun"
          :v-errors="errors" v-validate="" :select2="{ entity: 'mun/uf/' + part.uf, minlength: 2 }"></form-field>
        <form-field v-model="part.codpais" type="select2" col="6" :metadata="metadata.part.codpais" name="codpais"
          :v-errors="errors" v-validate="metadata.part.codpais.validator"></form-field>
      </div>
    </div>

    <!-- FORMULARIO COMPLETO -->
    <div class="default-container" id="participanteForm" v-if="formatoTela == 'normal'">
      <bar-manut single-entity="Participante" :crud="this.localCrud" :disableSave="this.disableSave" :btn-delete="true"
        @closeform="handleCloseForm" @delete="apiDelete()" @save="handleSave(false)" @savenew="handleSave(true)">
      </bar-manut>

      <validation v-if="nfeValidations" class="mt-3" title="Erros de Validação" :showcontinueanyway="true"
        :messages="nfeValidations" @continueanyway="nfeValidateContinueAnyway"></validation>
      <!-- dados do participante -->
      <div class="deafult-container">
        <label-title title="Dados do Participante" class="mb-2 mt-2"></label-title>
        <div class="row">
          <div class="col-md-3 col-12">
            <input-switch type="success" label="Cliente" v-model="part.cliente" value-checked="S" value-unchecked="N"
              :metadata="metadata.part.cliente"></input-switch>
          </div>
          <div class="col-md-3 col-12">
            <input-switch type="success" label="Fornecedor" v-model="part.forn" value-checked="S" value-unchecked="N"
              :metadata="metadata.part.forn"></input-switch>
          </div>
          <div class="col-md-3 col-12">
            <input-switch type="success" label="Transportadora" v-model="part.transp" value-checked="S"
              value-unchecked="N" :metadata="metadata.part.transp"></input-switch>
          </div>
        </div>

        <div class="row">
          <form-field v-model="part.codpart" type="text" col="2" :metadata="metadata.part.codpart" name="codpart"
            :v-errors="errors" v-validate="metadata.part.codpart.validator" disabled></form-field>
          <form-field v-model="part.dtcadastro" type="date" col="2" :metadata="metadata.part.dtcadastro"
            name="dtcadastro" :v-errors="errors" v-validate="metadata.part.dtcadastro.validator" disabled></form-field>
          <form-field v-model="part.stpart" type="select" col="2" :metadata="metadata.part.stpart" name="stpart"
            :v-errors="errors" v-validate="metadata.part.stpart.validator"></form-field>
        </div>
        <div class="row">
          <form-field ref="tppessoa" v-model="part.tppessoa" type="select" col="3" :metadata="metadata.part.tppessoa"
            name="tppessoa" :v-errors="errors" v-validate="metadata.part.tppessoa.validator"
            :disabled="part.part_com_movimento == 'S'"></form-field>
          <form-field v-if="part.tppessoa == 'J'" v-model="part.cnpjcpf" type="cnpj" col="3"
            :metadata="metadata.part.cnpjcpf" name="cnpjcpf" id="cnpjcpf" :v-errors="errors"
            v-validate="{ cnpj: true, required: true, min: 14, max: 14 }"
            :disabled="part.part_com_movimento == 'S'"></form-field>
          <form-field v-if="part.tppessoa == 'F'" v-model="part.cnpjcpf" id="cnpjcpf" type="cnpj" col="3"
            :metadata="metadata.part.cnpjcpf" name="cnpjcpf" :v-errors="errors"
            v-validate="{ cpf: true, required: true,  min: 11, max: 11 }"></form-field>

          <form-field v-if="showPreencherCadastro" v-model="part.uf" type="text" col="1" :metadata="metadata.part.uf">
          </form-field>
          <v-button v-if="showPreencherCadastro" label="Preencher Cadastro" icon="" @click="handlePreencherCadastro()"
            title="Para uma pesquisa mais completa, informe o estado!"></v-button>

          <form-field v-show="part.tppessoa != 'J'" v-model="part.rg" type="text" col="3" :metadata="metadata.part.rg"
            name="rg" :v-errors="errors" v-validate="metadata.part.rg.validator"></form-field>
        </div>
        <div class="row">
          <form-field v-model="part.nome" type="text" col="6" :metadata="metadata.part.nome" name="nome" id="nome"
            :v-errors="errors" v-validate="metadata.part.nome.validator"></form-field>
          <div class="w-100"></div>
          <form-field v-model="part.fantasia" type="text" col="6" :metadata="metadata.part.fantasia" name="fantasia"
            id="fantasia" :v-errors="errors" v-validate="metadata.part.fantasia.validator"></form-field>
        </div>

        <div v-if="part.tppessoa == 'J'" class="row">
          <form-field v-model="part.contricms" type="select" col="4" :metadata="metadata.part.contricms"
            name="contricms" id="contricms" :v-errors="errors" v-validate="metadata.part.contricms.validator">
          </form-field>
          <form-field v-if="part.contricms == 'S'" v-model="part.iest" type="text" col="4"
            :metadata="metadata.part.iest" name="iest" :v-errors="errors" v-validate="metadata.part.iest.validator">
          </form-field>
          <div class="w-100"></div>
          <form-field v-model="part.optsimples" type="select" col="4" :metadata="metadata.part.optsimples"
            name="optsimples" :v-errors="errors" v-validate="metadata.part.optsimples.validator"></form-field>
          <div class="w-100"></div>
          <form-field v-model="part.tpcliente" type="select" col="4" :metadata="metadata.part.tpcliente"
            name="tpcliente" :v-errors="errors" v-validate="metadata.part.tpcliente.validator"></form-field>
          <div class="w-100"></div>
          <form-field v-model="part.zfranca" type="select" col="4" :metadata="metadata.part.zfranca" name="zfranca"
            :v-errors="errors" v-validate="metadata.part.zfranca.validator"></form-field>
          <form-field v-if="part.zfranca == 'S'" v-model="part.inscsuframa" type="text" col="4"
            :metadata="metadata.part.inscsuframa" name="inscsuframa" :v-errors="errors"
            v-validate="metadata.part.inscsuframa.validator"></form-field>
          <form-field v-model="part.tpentegov" type="select" col="4" :metadata="metadata.part.tpentegov"
            name="tpentegov" :v-errors="errors" v-validate="metadata.part.tpentegov.validator"></form-field>

        </div>
        <!-- <div class="row">
                    <form-field v-model="part.limcred" type="value" col="4" :metadata="metadata.part.limcred"></form-field>
                </div> -->
        <div class="row">
          <form-field v-if="part.cliente == 'S'" v-model="part.codgrucli" type="select2" col="4"
            :metadata="metadata.part.codgrucli" name="codgrucli" :v-errors="errors"
            v-validate="metadata.part.codgrucli.validator" :add-button="true" @clickAdd="handleIncluir('grucli')">
          </form-field>
          <div class="w-100"></div>
          <form-field v-if="part.cliente == 'S'" v-model="part.codramo" type="select2" col="4"
            :metadata="metadata.part.codramo" name="codramo" :v-errors="errors"
            v-validate="metadata.part.codramo.validator" :add-button="true" @clickAdd="handleIncluir('ramoat')">
          </form-field>
        </div>

        <!-- ENDERECO -->
        <div id="addr">
          <label-title title="Endereço Principal" class="mb-2 mt-2"></label-title>

          <div class="row">
            <form-field v-model="part.cep" type="cep" col="2" :metadata="metadata.part.cep" name="cep" id="cep"
              :v-errors="errors" v-validate="metadata.part.cep.validator" @update="updateCep"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.ende" type="text" col="6" :metadata="metadata.part.ende" name="ende"
              :v-errors="errors" v-validate="metadata.part.ende.validator"></form-field>
            <form-field v-model="part.endenr" type="text" col="3" :metadata="metadata.part.endenr" name="endenr"
              id="endenr" :v-errors="errors" v-validate="metadata.part.endenr.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.endecomp" type="text" col="4" :metadata="metadata.part.endecomp" name="endecomp"
              :v-errors="errors" v-validate="metadata.part.endecomp.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.bairro" type="text" col="4" :metadata="metadata.part.bairro" name="bairro"
              :v-errors="errors" v-validate="metadata.part.bairro.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.uf" type="select2" col="4" :metadata="metadata.part.uf" name="uf"
              :v-errors="errors" v-validate="metadata.part.uf.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.codmun" type="select2" col="4" :metadata="metadata.part.codmun" name="codmun"
              :v-errors="errors" v-validate="metadata.part.codmun.validator"
              :select2="{ entity: 'mun/uf/' + part.uf, minlength: 2 }"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.codpais" type="select2" col="4" :metadata="metadata.part.codpais" name="codpais"
              :v-errors="errors" v-validate="metadata.part.codpais.validator"></form-field>
          </div>
        </div>

        <!-- fiscal/faturamento -->
        <div id="fiscal" v-if="part.cliente == 'S'">
          <label-title title="Informações Para Faturamento" class="mb-2 mt-2"></label-title>
          <div class="row">
            <form-field v-model="part.codnatfinrec" type="select2" col="4" :metadata="metadata.part.codnatfinrec"
              name="codnatfinrec" :v-errors="errors" v-validate="metadata.part.codnatfinrec.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.emaildanfe" type="text" col="6" :metadata="metadata.part.emaildanfe" case="lower"
              name="emaildanfe" :v-errors="errors" v-validate="metadata.part.emaildanfe.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.emailcobranca" type="text" col="6" :metadata="metadata.part.emailcobranca"
              case="lower" name="emailcobranca" :v-errors="errors" v-validate="metadata.part.emailcobranca.validator">
            </form-field>
            <!-- <form-field v-model="part.codvendr" type="select2" col="3" :metadata="metadata.part.codvendr"
                            name="codvendr" :v-errors="errors" v-validate="metadata.part.codvendr.validator"
                            :add-button="true" @clickAdd="handleIncluir('vend')"></form-field>
                        <form-field v-model="part.pcomir" type="value" col="3" :metadata="metadata.part.pcomir"
                            name="pcomir" :v-errors="errors" v-validate="metadata.part.pcomir.validator"></form-field>
                        <form-field v-if="false" v-model="part.codpagven" type="select2" col="3" :metadata="metadata.part.codpagven"
                            name="codpagven" :v-errors="errors" v-validate="metadata.part.codpagven.validator"></form-field>
                        <form-field v-model="part.codparttr" type="select2" col="3" :metadata="metadata.part.codparttr"
                            name="codparttr" :v-errors="errors" v-validate="metadata.part.codparttr.validator"></form-field>
                        <form-field v-model="part.codnates" type="select2" col="3" :metadata="metadata.part.codnates"
                            name="codnates" :v-errors="errors" v-validate="metadata.part.codnates.validator"></form-field>
                        <form-field v-model="part.codtabpre" type="select2" col="3" :metadata="metadata.part.codtabpre"
                            name="codtabpre" :v-errors="errors" v-validate="metadata.part.codtabpre.validator"></form-field> -->
          </div>
          <div class="row">
            <form-field v-model="part.calcst" type="select" col="3" :metadata="metadata.part.calcst" name="calcst"
              :v-errors="errors" v-validate="metadata.part.calcst.validator"></form-field>
            <form-field v-if="part.calcst == 'M'" v-model="part.pcargamedia" type="value" col="3"
              :metadata="metadata.part.pcargamedia" name="pcargamedia" :v-errors="errors"
              v-validate="metadata.part.pcargamedia.validator"></form-field>
            <!-- <div class="w-100"></div>
                        <form-field v-model="part.zfranca" type="select" col="3" :metadata="metadata.part.zfranca"
                            name="zfranca" :v-errors="errors" v-validate="metadata.part.zfranca.validator"></form-field>
                        <form-field v-if="part.zfranca == 'S'" v-model="part.inscsuframa" type="text" col="3" :metadata="metadata.part.inscsuframa"
                            name="inscsuframa" :v-errors="errors" v-validate="metadata.part.inscsuframa.validator"></form-field>
                        <form-field v-if="part.zfranca == 'S'" v-model="part.dtsuframa" type="date" col="3" :metadata="metadata.part.dtsuframa"
                            name="dtsuframa" :v-errors="errors" v-validate="metadata.part.dtsuframa.validator"></form-field> -->
            <div class="w-100"></div>
            <form-field v-model="part.stipipart" type="select" col="3" :metadata="metadata.part.stipipart"
              name="stipipart" :v-errors="errors" v-validate="metadata.part.stipipart.validator"></form-field>
            <form-field v-if="part.stipipart == 'S'" v-model="part.validadeipi" type="date" col="3"
              :metadata="metadata.part.validadeipi" name="validadeipi" :v-errors="errors"
              v-validate="metadata.part.validadeipi.validator"></form-field>
            <form-field v-if="part.stipipart == 'S'" v-model="part.cenqipi" type="value" col="3"
              :metadata="metadata.part.cenqipi" name="cenqipi" :v-errors="errors"
              v-validate="metadata.part.cenqipi.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.calcreten" type="select" col="3" :metadata="metadata.part.calcreten"
              name="calcreten" :v-errors="errors" v-validate="metadata.part.calcreten.validator"></form-field>
            <form-field v-if="part.calcreten == 'S'" v-model="part.pretcsll" type="value" col="3"
              :metadata="metadata.part.pretcsll" name="pretcsll" :v-errors="errors"
              v-validate="metadata.part.pretcsll.validator"></form-field>
            <form-field v-if="part.calcreten == 'S'" v-model="part.pretcofins" type="value" col="3"
              :metadata="metadata.part.pretcofins" name="pretcofins" :v-errors="errors"
              v-validate="metadata.part.pretcofins.validator"></form-field>
            <form-field v-if="part.calcreten == 'S'" v-model="part.pretpis" type="value" col="3"
              :metadata="metadata.part.pretpis" name="pretpis" :v-errors="errors"
              v-validate="metadata.part.pretpis.validator"></form-field>
            <form-field v-if="part.calcreten == 'S'" v-model="part.pretinss" type="value" col="3"
              :metadata="metadata.part.pretinss" name="pretinss" :v-errors="errors"
              v-validate="metadata.part.pretinss.validator"></form-field>
            <form-field v-if="part.calcreten == 'S'" v-model="part.pretirrf" type="value" col="3"
              :metadata="metadata.part.pretirrf" name="pretirrf" :v-errors="errors"
              v-validate="metadata.part.pretirrf.validator"></form-field>
            <!-- <div class="w-100"></div>
                        <form-field v-model="part.regexercito" type="text" col="3" :metadata="metadata.part.regexercito"
                            name="regexercito" :v-errors="errors" v-validate="metadata.part.regexercito.validator"></form-field> -->
          </div>
        </div>

        <!-- contatos -->
        <div id="contacts">
          <label-title title="Contatos" class="mb-2 mt-2"></label-title>
          <div class="row pl-3">
            <div class="col-md-2 col-3" v-if="partcontato.length > 0">
              <v-label :metadata-field="metadata.partcontato.nomecontato"></v-label>
            </div>
            <div class="col-md-2 col-3">
              <v-label :metadata-field="metadata.partcontato.email"></v-label>
            </div>
            <div class="col-md-2 col-3">
              <v-label :metadata-field="metadata.partcontato.fone1"></v-label>
            </div>
            <div class="col-md-2 col-3">
              <v-label :metadata-field="metadata.partcontato.fone2"></v-label>
            </div>
            <div class="col-md-2 col-3">
              <v-label :metadata-field="metadata.partcontato.fone3"></v-label>
            </div>
          </div>
          <div class="row pl-3" v-for="(cont, index) in partcontato" :key="index">
            <div class="col-md-2 col-3">
              <div class="form-group">
                <!-- <v-label :metadata-field="metadata.partcontato.nomecontato" v-if="index == 0" ></v-label> -->
                <input type="text" name="nomecontato" class="form-control form-control-sm"
                  @keyup.enter="focusControl($event)" v-model="cont.nomecontato" maxlenght="60" :disabled="isView" />
              </div>
            </div>
            <div class="col-md-2 col-3">
              <div class="form-group">
                <!-- <v-label :metadata-field="metadata.partcontato.email" v-if="index == 0" ></v-label> -->
                <input-email ref="input" class="form-control form-control-sm" @update="updateEmail"
                  @keyup.enter="focusControl($event)" :tabindex="tabindex" maxlength="255" :disabled="disabled"
                  :value="value" @input="input" v-if="type == 'email'">
                </input-email>

                <input type="text" name="email" class="form-control form-control-sm" v-model="cont.email"
                  maxlenght="255" :disabled="isView" @keyup.enter="focusControl($event)" />
                <small class="error" v-if="!cont.email">{{
                    "Campo obrigatório"
                }}</small>
              </div>
            </div>
            <div class="col-md-2 col-2">
              <div class="form-group">
                <!-- <v-label :metadata-field="metadata.partcontato.fone1" v-if="index == 0" ></v-label> -->
                <input-fone class="form-control form-control-sm" v-model="cont.fone1" :disabled="isView"></input-fone>
                <small class="error" v-if="!cont.fone1">{{
                    "Campo obrigatório"
                }}</small>
              </div>
            </div>
            <div class="col-md-2 col-2">
              <div class="form-group">
                <!-- <v-label :metadata-field="metadata.partcontato.fone2" v-if="index == 0" ></v-label> -->
                <input-fone class="form-control form-control-sm" v-model="cont.fone2" :disabled="isView"></input-fone>
              </div>
            </div>
            <div class="col-md-2 col-2">
              <div class="form-group">
                <!-- <v-label :metadata-field="metadata.partcontato.fone3" v-if="index == 0" ></v-label> -->
                <input-fone class="form-control form-control-sm" v-model="cont.fone3" :disabled="isView"></input-fone>
              </div>
            </div>
            <div class="col-md-2 col-2">
              <v-button label="" title="Excluir Contato" icon="fa-trash" :tabindex="1"
                @click="handleDeleteContact(index)"></v-button>
              <v-button label="" :nb-btdef="index + 1 == part.partcontatoseq" :tabindex="1" title="Contato Preferencial"
                icon="fa-check" @click="handlePrefContact(index)"></v-button>
            </div>
          </div>

          <div class="row pl-3">
            <div class="col-md-12 col-12">
              <div class="btn-group">
                <a href="javascript:void(0);" class="btn btn-sm btn-outline-secondary" style="margin-right: 5px"
                  :tabindex="1" @click="handleAddContact()">Adicionar Contato</a>
              </div>
            </div>
          </div>
          <br />
        </div>

        <!-- endereço cobrança -->
        <!-- <div v-if="part.cliente=='S'">
                    <div v-if="!showInfCob" class="mt-2 mb-2">
                        <a href="javascript:void(0);" @click="showInfCob = true"><i class="fa fa-caret-down" aria-hidden="true"></i> Exibir endereço de cobrança</a>
                    </div>
                    <div v-if="showInfCob">
                        <label-title title="Endereço de Cobrança" class="mb-2 mt-2"></label-title><br>
                        <div class="row">
                            <form-field v-model="part.cepcob" type="cep" col="2" :metadata="metadata.part.cepcob"
                                name="cepcob" :v-errors="errors" v-validate="metadata.part.cepcob.validator" @update="updateCepCob"></form-field>
                            <form-field v-model="part.endecob" type="text" col="4" :metadata="metadata.part.endecob"
                                name="endecob" :v-errors="errors" v-validate="metadata.part.endecob.validator"></form-field>
                            <form-field v-model="part.endenrcob" type="text" col="2" :metadata="metadata.part.endenrcob"
                                name="endenrcob" :v-errors="errors" v-validate="metadata.part.endenrcob.validator"></form-field>
                            <form-field v-model="part.endecompcob" type="text" col="4" :metadata="metadata.part.endecompcob"
                                name="endecompcob" :v-errors="errors" v-validate="metadata.part.endecompcob.validator"></form-field>
                            <form-field v-model="part.bairrocob" type="text" col="3" :metadata="metadata.part.bairrocob"
                                name="bairrocob" :v-errors="errors" v-validate="metadata.part.bairrocob.validator"></form-field>
                            <form-field v-model="part.ufcob" type="select2" col="3" :metadata="metadata.part.ufcob"
                                name="ufcob" :v-errors="errors" v-validate="metadata.part.ufcob.validator"></form-field>
                            <form-field v-model="part.codmuncob" type="select2" col="3" :metadata="metadata.part.codmuncob"
                                name="codmuncob" :v-errors="errors" v-validate="metadata.part.codmuncob.validator"
                                :select2="{entity: 'mun/uf/' + part.uf, minlength: 2}"></form-field>
                        </div>
                    </div>
                </div> -->

        <!-- financeiro/credito -->
        <div v-if="part.cliente == 'S'">
          <div v-if="!showInfCredito" class="mt-2 mb-2">
            <a href="javascript:void(0);" @click="showInfCredito = true" :tabindex="1"><i class="fa fa-caret-down"
                aria-hidden="true"></i> Exibir
              informações de crédito</a>
          </div>
          <div v-if="showInfCredito">
            <label-title title="Informações de Crédito" class="mb-2 mt-2"></label-title><br />
            <div class="row">
              <form-field v-model="part.stcred" type="select" col="3" :metadata="metadata.part.stcred" name="stcred"
                :v-errors="errors" v-validate="metadata.part.stcred.validator"></form-field>
              <form-field v-model="part.limcred" type="value" col="3" :metadata="metadata.part.limcred" name="limcred"
                :v-errors="errors" v-validate="metadata.part.limcred.validator"></form-field>
              <form-field v-model="part.maxdiasatraso" type="value" col="3" :metadata="metadata.part.maxdiasatraso"
                name="maxdiasatraso" :v-errors="errors" v-validate="metadata.part.maxdiasatraso.validator"></form-field>
              <form-field v-model="part.maxvlratraso" type="value" col="3" :metadata="metadata.part.maxvlratraso"
                name="maxvlratraso" :v-errors="errors" v-validate="metadata.part.maxvlratraso.validator"></form-field>
            </div>
            <div class="row">
              <!-- <form-field v-model="part.codportador" type="select2" col="3" :metadata="metadata.part.codportador"
                                name="codportador" :v-errors="errors" v-validate="metadata.part.codportador.validator"></form-field>
                            <form-field v-model="part.codinstrban1" type="select2" col="3" :metadata="metadata.part.codinstrban1"
                                name="codinstrban1" :v-errors="errors" v-validate="metadata.part.codinstrban1.validator"></form-field>
                            <form-field v-model="part.codinstrban2" type="select2" col="3" :metadata="metadata.part.codinstrban2"
                                name="codinstrban2" :v-errors="errors" v-validate="metadata.part.codinstrban2.validator"></form-field> -->
            </div>
          </div>
        </div>

        <!-- dados de fornecedor -->
        <div id="forn" v-if="part.forn == 'S' || part.transp == 'S'">
          <label-title title="Informações de Fornecedor/Transportadora" class="mb-2 mt-2"></label-title><br />
          <div class="row">
            <form-field v-model="part.codgrufor" type="select2" col="4" :metadata="metadata.part.codgrufor"
              name="codgrufor" :v-errors="errors" v-validate="metadata.part.codgrufor.validator" :add-button="true"
              @clickAdd="handleIncluir('grufor')"></form-field>

            <div class="w-100"></div>
            <form-field v-model="part.codnatfindes" type="select2" col="4" :metadata="metadata.part.codnatfindes"
              name="codnatfindes" :v-errors="errors" v-validate="metadata.part.codnatfindes.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-model="part.contabanco" type="number" col="2" :metadata="metadata.part.contabanco"
              name="contabanco" :v-errors="errors" v-validate="metadata.part.contabanco.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.contaagencia" type="text" col="2" :metadata="metadata.part.contaagencia"
              name="contaagencia" :v-errors="errors" v-validate="metadata.part.contaagencia.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.contacorrente" type="value" col="2" :metadata="metadata.part.contacorrente"
              name="contacorrente" :v-errors="errors" v-validate="metadata.part.contacorrente.validator"></form-field>
            <div class="w-100"></div>
            <form-field v-model="part.contanome" type="text" col="4" :metadata="metadata.part.contanome"
              name="contanome" :v-errors="errors" v-validate="metadata.part.contanome.validator"></form-field>
          </div>
        </div>

        <!-- <div v-if="administrador && metadata.part.codusuario.select2 && metadata.part.codusuario.select2.entity"> -->
        <div v-if="administrador">
          <div v-if="!showInfUsuario" class="mt-2 mb-2">
            <a href="javascript:void(0);" @click="showInfUsuario = true" :tabindex="1"><i class="fa fa-caret-down"
                aria-hidden="true"></i> Exibir
              informações de usuário</a>
          </div>
          <div v-if="showInfUsuario">
            <label-title title="Usuario vinculado ao cliente" class="mb-2 mt-2"></label-title><br />
            <div class="row">
              <form-field v-model="part.codusuario" type="select2" col="3" :metadata="metadata.part.codusuario"
                :disabled="isView" name="codusuario" :v-errors="errors" v-validate="metadata.part.codusuario.validator">
              </form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <vue-snotify></vue-snotify> -->

    <md-message v-if="showMessage" :code="codeMessage" @close="closeMessage()" @confirm="handleConfirmMessage()">
    </md-message>

    <div class="nb-modal-mask" v-if="showRamoForm">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body">
            <ramoat-form crud="ins" @closeform="closeRamoForm"></ramoat-form>
          </div>
        </div>
      </div>
    </div>

    <div class="nb-modal-mask" v-if="showVendForm">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body">
            <vend-form crud="ins" @closeform="closeVendForm"></vend-form>
          </div>
        </div>
      </div>
    </div>

    <div class="nb-modal-mask" v-if="showGrucliForm">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body">
            <grucli-form crud="ins" @closeform="closeGrucliForm"></grucli-form>
          </div>
        </div>
      </div>
    </div>

    <div class="nb-modal-mask" v-if="showGruforForm">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body">
            <grufor-form crud="ins" @closeform="closeGruforForm"></grufor-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SysVars } from "../main";
import {
  apiORDSpost,
  apiORDSdelete,
  apiConsultaCadastro
} from "../shared/api-functions";
import GrucliForm from "./grucli-form";
import GruforForm from "./grufor-form";
import NatfinForm from "./natfin-form";
import VendForm from "./vend-form";
import RamoatForm from "./ramoat-form";
import { hasHiddenParent } from "../shared/utils";
import Tourguide from 'tourguidejs';

export default {
  props: {
    index: "",
    crud: "",
    varejo: Boolean,
    forcaVendas: Boolean,
    crm: Boolean,
    transportadora: Boolean,
    customerValidate: {},
    receivedData: null
  },

  data() {
    return {
      crudText: "",

      metadata: this.$store.getters.getEntities.metadata,
      part: { ...this.$store.getters.getEntities.part },
      partcontato: [],

      showMessage: false,
      message: "",
      isView: false,
      disableSave: false,
      changed: false,
      duplicado: false,

      showGrucliForm: false,
      showGruforForm: false,
      showRamoForm: false,
      showVendForm: false,

      showInfCredito: false,
      showInfUsuario: false,
      showInfCob: false,
      errorsContact: false,
      // campoteste: [],

      partOptions: [
        { id: "C", text: "Cliente" },
        { id: "F", text: "Fornecedor" },
        { id: "T", text: "Transportadora" }
      ],

      nfeValidations: [],
      passNfeValidate: true,

      hasManyCustomers: false,
      steps: [
        {
          "selector": "",
          "step": 1,
          "title": `Vamos começar!`,
          "content": "Vamos te guiar passo a passo por todo o processo de cadastro de cliente.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#cnpjcpf",
          "step": 2,
          "title": `CNPJ`,
          "content": "Informe o CNPJ do cliente.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#nome",
          "step": 3,
          "title": `Nome`,
          "content": "Informe o Nome do cliente.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#fantasia",
          "step": 4,
          "title": `Nome Fantasia`,
          "content": "Informe o Nome Fantasia do cliente.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#contricms",
          "step": 5,
          "title": `O cliente é Contribuinte de ICMS`,
          "content": "Informe se o cliente é contribuinte de ICMS.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#cep",
          "step": 6,
          "title": `CEP do Endereço`,
          "content": "Informe o CEP do endereço do cliente.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#endenr",
          "step": 7,
          "title": `Numero do Endereço`,
          "content": "Informe o Nr. do endereço do cliente.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#email",
          "step": 7,
          "title": `E-mail de contato`,
          "content": "Informe o e-mail de contato do cliente.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#fone1",
          "step": 7,
          "title": `Telefone de contato`,
          "content": "Informe o telefone de contato do cliente.",
          // "image": "https://somehost.com/image.jpeg"
        },



      ],




    }
  },

  computed: {
    administrador: function () {
      return SysVars.usuarioAdministrador;
    },

    loja_b2b: function () {
      return SysVars.loja_b2b;
    },

    novoRegistro: function () {
      return this.crud == SysVars.crudI || this.$route.params.id == "novo";
    },

    localCrud: function () {
      if (this.$route.params.id == "novo") return SysVars.crudI;
      else return this.crud;
    },

    showPreencherCadastro: function () {
      return (
        this.part.tppessoa == "J" &&
        this.part.cnpjcpf &&
        this.part.cnpjcpf.length == 14
      );
    },

    formatoTela: function () {
      if (this.transportadora) return "transportadora";
      else if (this.varejo) {
        return "varejo";
      } else if (this.forcaVendas || this.crm || this.pedido) {
        return "forcavendas";
      } else {
        return "normal";
      }
    },

    validationHandler: function () {
      return this.errors.items.length;
    },

    cnpjcpf: function () {
      return this.part.cnpjcpf;
    },

    tppessoa: function () {
      return this.part.tppessoa;
    },
    appNFe: function () {
      return SysVars.appNFe;
    },
    appERP: function () {
      return SysVars.appERP;
    },
    usaIntegracao: function () {
      return SysVars.usaIntegracao;
    },
    showGuia: function () {
      return SysVars.guia
    },


  },

  watch: {
    validationHandler: function () {
      this.disableSave = this.errors.items.length > 0; //habilita e desabilita botao salvar
    },

    tppessoa: function (oldvalue, newvalue) {
      if (oldvalue != newvalue) {
        this.pesquisaCNPJ();
      }
    },

    cnpjcpf: function (oldvalue, newvalue) {
      if (oldvalue != newvalue) {
        this.pesquisaCNPJ();
      }
    },

    'part.codusuario': {
      handler(val) {
        if (val) {
          this.showInfUsuario = true;
        }
      },
      immediate: true
    },

    part: {
      handler() {
        this.changed = true;

        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip();
        });
      },
      deep: true
    }
  },

  methods: {
    focusControl: function (event) {
      event.preventDefault();
      var thisIndex = jQuery(event.target).index(SysVars.sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(SysVars.sFocusControl);
      for (var x = next; x < obj.length; x++) {
        if (
          jQuery(obj[x]).prop("tabindex") === 0 &&
          !jQuery(obj[x]).is("disabled") &&
          !hasHiddenParent(obj[x])
        ) {
          jQuery(obj[x]).focus();
          return;
        }
      }
      for (var x = 0; x < obj.length; x++) {
        if (
          jQuery(obj[x]).prop("tabindex") === 0 &&
          !jQuery(obj[x]).is("disabled") &&
          !hasHiddenParent(obj[x])
        ) {
          jQuery(obj[x]).focus();
          return;
        }
      }
    },

    nfeValidateContinueAnyway() {
      this.passNfeValidate = false;
      this.handleSave();
    },

    nfeValidate() {
      this.nfeValidations = [];
      if (!this.passNfeValidate) return;

      if (this.usaIntegracao || this.appERP || this.appNFe) {
        if (
          this.part.tppessoa == "J" &&
          !this.part.cnpjcpf &&
          this.part.cnpjcpf.length < 14
        ) {
          this.nfeValidations.push("CNPJ é inválido.");
        }
        if (!this.part.cep || this.part.cep.length != 8) {
          this.nfeValidations.push("CEP inválido.");
        }
        if (!this.part.ende) {
          this.nfeValidations.push("Endereço não informado.");
        }
        if (!this.part.endenr) {
          this.nfeValidations.push("Número do Endereço não informado.");
        }
        if (!this.part.codmun) {
          this.nfeValidations.push("Município não informado.");
        }
      }
    },

    handlePreencherCadastro() {
      if (!this.cnpjcpf) {
        this.$erpToastError("Preencha o CNPJ e o estado do cliente");
        return;
      }
      apiConsultaCadastro(
        this,
        this.cnpjcpf,
        this.part.uf,
        this.updateDadosCadastrais
      );
    },

    updateDadosCadastrais(dados) {
      this.part.nome = (dados.nome || "").substr(0, 100);
      this.part.fantasia = (dados.fantasia || dados.nome || "").substr(0, 100);
      this.part.cnae = dados.cnae;
      this.part.iest = dados.ie;

      if (dados.ie && dados.ie != "ISENTO") {
        this.part.contricms = "S";
      } else if (dados.ie == "ISENTO") {
        this.part.contricms = "I";
      } else {
        this.part.contricms = "N";
      }

      this.part.ende = (dados.endereco || "").substr(0, 100);
      this.part.endenr = dados.nr;
      this.part.endecompl = dados.complemento;
      this.part.mun = dados.mun;
      this.part.codmun = dados.cMun;
      this.part.bairro = dados.bairro;
      this.part.uf = dados.uf;
      this.part.cep = dados.cep;
    },

    closeForm() {
      if (this.$route.params && this.$route.params.id == "novo")
        this.$router.go(-1);
      else this.$emit("closeform", this.part.codpart);
    },

    handleAction(act) {
      if (act == 0) {
        //importação de cadastro de clientes
        this.$router.push("/importa/clientes");
      }
    },

    handleCloseForm() {
      this.closeForm();
      // if (this.changed) {                     // se ocorreu alguma alteração exibe mensagem antes de fechar
      //     this.showMessageModal('closeform')
      // } else {
      //     this.closeForm()
      // }
    },

    handleIncluir(pTipo) {
      //exibe tela de cadastro
      if (this.isView) {
        return;
      }

      if (pTipo === "vend") {
        this.showVendForm = true;
      }

      if (pTipo === "grucli") {
        this.showGrucliForm = true;
      }

      if (pTipo === "grufor") {
        this.showGruforForm = true;
      }

      if (pTipo === "ramoat") {
        this.showRamoForm = true;
      }
    },

    closeGrucliForm(id) {
      if (id) this.part.codgrucli = id;
      this.showGrucliForm = false;
    },

    closeVendForm(id) {
      if (id) this.part.codvendr = id;
      this.showVendForm = false;
    },

    closeGruforForm(id) {
      if (id) this.part.codgrufor = id;
      this.showGruforForm = false;
    },

    closeRamoForm(id) {
      if (id) this.part.codramo = id;
      this.showRamoForm = false;
    },

    handleConfirmMessage() {
      //EVENTO DO BOTAO "CONFIRMAR" DA MENSAGEM
      if (this.codeMessage == "closeform") {
        //fecha o formulario e retornar para o anterior
        this.closeMessage();
        this.closeForm();
      }
    },

    showMessageModal(code) {
      //exibe uma mensagem em "code"
      this.codeMessage = code;
      this.showMessage = true;
    },

    closeMessage() {
      this.showMessage = false;
    },

    handleAddContact() {
      //BOTAO PARA ADICIONAR NOVO CONTATO
      var cont = { ...this.$store.getters.getEntities.partcontato };
      this.partcontato.push(cont);
    },
    handleDeleteContact(index) {
      if (this.part.partcontatoseq == index + 1) {
        this.part.partcontatoseq = null;
      }
      this.partcontato.splice(index, 1);
    },
    handlePrefContact(index) {
      this.part.partcontatoseq = index + 1;
    },

    updateCep() {
      //CARREGA INFORMACOES DO CEP DIGITADO
      this.part.ende = SysVars.endereco.logradouro;
      this.part.bairro = SysVars.endereco.bairro;
      this.part.codmun = SysVars.endereco.ibge;
      this.part.uf = SysVars.endereco.uf;
      this.part.codpais = "1058";
    },

    updateCepCob() {
      //CARREGA INFORMACOES DO CEP DIGITADO
      this.part.endecob = SysVars.endereco.logradouro;
      this.part.bairrocob = SysVars.endereco.bairro;
      this.part.codmuncob = SysVars.endereco.ibge;
      this.part.ufcob = SysVars.endereco.uf;
      this.part.codpaiscob = "1058";
    },

    async loadData() {
      //carrega o participante para alteracao ou visualizacao
      await this.$store.dispatch("loadPart", { id: this.index });
      if (this.$store.getters.getPart) {
        this.part = { ...this.$store.getters.getPart[0] };
        this.partcontato = [];
        if (this.$store.getters.getPart[0].partcontato.length) {
          for (
            var x = 0;
            x < this.$store.getters.getPart[0].partcontato.length;
            x++
          ) {
            this.partcontato.push(
              this.$store.getters.getPart[0].partcontato[x]
            );
          }
        }
      }
      this.changed = false;
      if (this.partcontato.length < 1 && !this.varejo) {
        this.handleAddContact();
      }
    },

    async pesquisaCNPJ() {
      //checa se já existe participante cadastrado com o cnpj/cpf informado

      this.duplicado = false;

      if (this.part.tppessoa == null || this.part.cnpjcpf == null) {
        return;
      }

      if (this.part.tppessoa == "F" && this.part.cnpjcpf.length < 11) {
        return;
      }

      if (this.part.tppessoa == "J" && this.part.cnpjcpf.length < 14) {
        return;
      }

      await this.$store.dispatch("loadPartDoc", {
        tppessoa: this.part.tppessoa,
        cnpjcpf: this.part.cnpjcpf
      });
      if (
        this.$store.getters.getPart &&
        this.$store.getters.getPart.length > 0
      ) {
        //sendo inclusao já carrega o participante encontrado para a tela
        this.duplicado = true;
        if (this.novoRegistro) {
          this.duplicado = false;
          this.part = { ...this.$store.getters.getPart[0] };

          this.partcontato = [];
          if (this.$store.getters.getPart[0].partcontato.length) {
            for (
              var x = 0;
              x < this.$store.getters.getPart[0].partcontato.length;
              x++
            ) {
              this.partcontato.push(
                this.$store.getters.getPart[0].partcontato[x]
              );
            }
          }
        } else if (
          this.$store.getters.getPart[0].codpart == this.part.codpart
        ) {
          this.duplicado = false;
          return;
        }
        this.$erpToastError(
          "Participante já cadastrado com o cnpj informado. Código: " +
          this.$store.getters.getPart[0].codpart
        );
      }
      this.changed = false;
    },

    async apiDelete(del) {
      //efetua a exclusao do participante

      var modulo = "cg/part/" + this.part.codpart;
      var sendData = {};

      const data = await apiORDSdelete(this.$store, modulo);
      this.$erpToastSuccess("Participante excluído.");
      this.closeForm();
      // this.errmessages = data.validation
    },

    handleSave() {
      //BOTAO SALVAR
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.errorsContact = true;
          this.$erpToastError(
            "Por favor, corrija os campos em destaque para continuar"
          );
        } else {
          this.handleValidationForm();
        }
      });
    },
    handleValidationForm() {
      if (this.duplicado) {
        this.$erpToastError("Participante já cadastrado com o cnpj informado.");
        return;
      }

      if (
        this.part.forn != "S" &&
        this.part.cliente != "S" &&
        this.part.transp != "S"
      ) {
        this.$erpToastError(
          "Informe se o participante é fornecedor, cliente ou transportadora."
        );
        return;
      }

      //obriga telefone no forca de vendas
      if (
        SysVars.appForcaVendas &&
        (!this.partcontato || this.partcontato.length == 0)
      ) {
        this.$erpToastError("Informe um contato para o cliente.");
        return;
      }

      if (this.partcontato) {
        let nullRequiredFields = this.partcontato.find(
          part => !part.fone1 || !part.email
        );

        if (nullRequiredFields && this.partcontato.length > 0) {
          this.$erpToastError("Informe o telefone ou e-mail do contato.");
        } else {
          if (!this.varejo) {
            this.nfeValidate();
            if (this.nfeValidations.length > 0) return;
          }
          this.apiPost();
        }
      }
    },
    async apiPost() {
      // console.log(this.part)
      //efetua a gravacao do participante
      this.passNfeValidate = true;

      var modulo = "cg/part/";
      var sendData = {};

      this.part.partcontato = this.partcontato;
      sendData = { part: this.part };

      var metodo = "post";
      var update = false;
      if (this.part.codpart != null) {
        metodo = "put";
        update = true;
      }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo);
      if (data.items) {
        this.part = data.items[0];

        this.$emit('sendData', this.part);

        if (this.part.validation) {
          this.errmessages = JSON.parse(this.part.validation);
        } else {
          if (update) {
            this.$erpToastSuccess("Participante alterado");
          } else {
            this.$erpToastSuccess("Participante inserido");
          }
          console.log("cliente:", this.$store.getters.getEntities.part);
          this.errmessages = {};
          this.closeForm();
        }
      }
      this.changed = false;
    }
  },

  components: {
    GruforForm,
    GrucliForm,
    VendForm,
    NatfinForm,
    RamoatForm,
    Tourguide
  },

  mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      if (this.varejo) {
        this.$refs.nome.focus();
      } else {
        this.$refs.tppessoa.focus();
      }
    });
  },

  beforeCreate() { },

  async created() {
    this.crudText = this.$crudText(this.localCrud)

    if (this.novoRegistro) {
      this.part.cliente = "S";
      this.part.forn = "N";
      this.part.transp = "N";
      this.part.tppessoa = "J";
      this.part.tpcliente = "F";
      this.part.optsimples = "N";
      this.part.zfranca = "N";
      // this.part.contricms = 'S'
      this.part.stipipart = "N";
      this.part.stcred = "L";
      this.part.calcreten = "N";
      this.part.calcst = "S";
      this.part.stpart = "A";
      this.part.tpfrete = "0";
      this.part.codpais = "1058";
      this.part.dtcadastro = this.$getDate();
      if (this.varejo) {
        this.part.tppessoa = "F";
      }
      if (this.transportadora) {
        this.part.cliente = "N";
        this.part.transp = "S";
      }
      if (this.orgcrm) {
        this.part.nome = this.orgcrm.nome;
        this.part.fantasia = this.orgcrm.fantasia;
        if (this.orgcrm.cnpj) {
          this.part.cnpjcpf = this.orgcrm.cnpj;
          this.part.tppessoa = "J";
        }
        if (this.orgcrm.cpf) {
          this.part.cnpjcpf = this.orgcrm.cpf;
          this.part.tppessoa = "F";
        }
      }
      //ALTERACAO GLAMOUR priscilasouzalira@hotmail.com
      if (SysVars.appForcaVendas) {
        this.part.tppessoa = null;
        this.part.uf = "SP";
      }
      if (this.partcontato.length < 1 && !this.varejo) {
        this.handleAddContact();
      }

      if (this.showGuia) {
        const filter = '{"nome":{"$ne":"CLIENTE PADRAO"}}'
        let params = { filter: filter }
        await this.$store.dispatch('loadPart', params)
        this.hasManyCustomers = (this.$store.getters.getPartList.length >= 1)
        if (this.showGuia && !this.hasManyCustomers) {
          var tourguide = new Tourguide({
            steps: this.steps
          });

          tourguide.start();
        }
      }
    } else {
      this.loadData();
    }

    //ALTERACAO GLAMOUR priscilasouzalira@hotmail.com
    if (SysVars.appForcaVendas) {
      this.metadata.part.fantasia.validator.required = false;
      this.metadata.part.cep.validator.required = false;
      this.metadata.part.ende.validator.required = false;
      this.metadata.part.endenr.validator.required = false;
      this.metadata.part.endecomp.validator.required = false;
      this.metadata.part.bairro.validator.required = false;
      this.metadata.part.codmun.validator.required = false;
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/customer-form.vue